<!-- 报名 -->
<template>
  <div class="stage-mod stage-sign">
    <div class="stage-box stage-box--simple">
      <div v-if="isBefore(preBegin - 3600000)" class="stage-box__msg">{{preBegin|time2text}}正式开赛</div>
      <div class="stage-box__msg">{{preBegin|time2text}}正式开赛(剩余{{leftFor(preBegin)}})</div>
      <van-button @click="submit" size="big" block type="danger">优先体验</van-button>
    </div>
  </div>

</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    name: 'st-sign',
    props: [],
    computed: {
      ...mapGetters(['preBegin', 'isValidUser', 'leftFor', 'isBefore'])
    },
    methods: {
      ...mapActions(['goTrialDK', 'goLogin']),
      async submit() {
        this.goTrialDK()
        // if (this.isValidUser) {
        //   this.goTrialDK()
        //   // await this.signSubmit()
        //   // this.$toast('报名成功')
        // } else {
        //   this.$dialog.alert({
        //     title: '参赛提醒',
        //     message: '<div class="ta_left">尊敬的用户您好！<br>为保证您的比赛成绩留存及奖项核实发放，<span class="blue">验证手机号即可参与大赛</span>。</div>',
        //     // cancelButtonText: '取消',
        //     confirmButtonText: '验证手机号'
        //   }).then(() => {
        //     this.goLogin()
        //     // on confirm
        //   }).catch(() => {
        //     // on cancel
        //   });
        // }

      }
    }
  }

</script>
